module.exports = __webpack_public_path__ + "static/media/intermittent-faults.c67787ac.svg";